// import axios from 'axios';
// import API from '../../plugins/api';
// import router from '../../router'

export default {
  state: {
    prop: true
  },
  getters: {
    templateProp: state => state.prop
  },
  mutations: {
    "SOCKET_PROP": (state,  status ) => {
      state.prop = status;
    },
    setProp(state, data) {
      state.prop = data;
    }
  },
  actions: {
    actionProp({commit}, data) {
      // commit("setProp", data)

      API
      .post('/prop', data)
      .then( res => {
        if(res.data){
          commit("setProp", res.data)
        } else {
          commit("setError", 'Credenciales incorrectas !');
        }
      })
      .catch(e => console.log(e))
    }
  }
};
